import { lazy } from "react";

const InstructorDashboard = lazy(() => import("./InstructorDashboard"));
const InstructorLessons = lazy(() => import("./InstructorLessons"));
const InstructorCourses = lazy(() => import("./InstructorCourses"));
const CreateCourse = lazy(() => import("./CreateCourse"));
const InstructorSupport = lazy(() => import("./InstructorSupport"));
const ScheduleStudents = lazy(() => import("./ScheduleStudents"));

export {
  InstructorDashboard,
  InstructorLessons,
  InstructorCourses,
  CreateCourse,
  InstructorSupport,
  ScheduleStudents,
};
